import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function addBonifications(body) {
  const response = await axios.post(
    `${REACT_APP_API}/bonifications`,
    body
  )
  
  return response.data.bonification
}
